
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,
  getBusSeqCode: (state) => state.busSeqCode,
  getMaxFromKm: (state) => state.fromKP,

  getAreas: (state) => state.areas,
}